import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6k08ohsex8: FaireBrandEntity = {
  token: "b_6k08ohsex8",
  type: "brand",
  name: "HYFVE",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9ae704a0db0147ee7404770ec50baf1ef6f2c8f054b36e1e64574d00c49084c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d53a2595f9a69993f8ba35ef0510322beb53865937a0ebf86b88e59a4b51991.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9ae704a0db0147ee7404770ec50baf1ef6f2c8f054b36e1e64574d00c49084c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d53a2595f9a69993f8ba35ef0510322beb53865937a0ebf86b88e59a4b51991.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 1557,
  isTopShop: true,
  isInsider: true,
  description:
    "HYFVE is a Los Angeles based wholesale women’s apparel brand with over 20 years of experience creating trend-driven fashion that helps retailers thrive. \n\nOur curated collections are designed for boutique buyers, online shops, and contemporary fashion retailers looking for high-margin styles with strong sell-through potential.\n\nKnown for bold silhouettes, youthful attitude, and fast-moving trends, HYFVE offers a diverse range of women’s clothing—from statement outerwear, co-ord sets, and jumpsuits to dresses, skirts, tops, and layering knits perfect for everyday styling and seasonal updates.\n\nWe proudly offer our sister label Double Zero within the HYFVE store. While HYFVE leans trend-forward and contemporary, Double Zero focuses on elevated basics, soft-touch fabrics, and minimalist essentials, giving buyers access to two bestselling aesthetics under one roof.\n\nHYFVE: Our signature line, offering trend-forward, young contemporary styles that capture the energy and innovation of LA fashion.\nDOUBLE ZERO: Specializing in elevated essentials and timeless basics, crafted with a focus on quality, fit, and fabric.\n\nWhether you're refreshing your boutique’s assortment or prepping for upcoming market demand, HYFVE delivers retail-ready pieces, new arrivals weekly, and a seamless buying experience across seasons.\n\nAnd as always, our philosophy remains:\nYour success is our success.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.658Z",
    importedBy: "entity-db-cli",
  },
};
